import styled from 'styled-components'
import theme from 'live/services/theme'
import Utils from 'live/lib/utils'
import { DropdownButton } from 'react-bootstrap'

export const DropDownWrapper = styled.ul`
    .dropdown-menu {
        top: -10px;
    }
`

export const DropDown = styled(DropdownButton)`
    background: none !important;
    border: none;
`
export const MenuWrapper = styled.div``

export const Table = styled.table`
    width: 100%;
    text-align: left;
    border-collapse: collapse;
    display: table;
    font-size: 12px;

    td,
    th {
        border: solid ${theme['dash-background']};
        border-width: 1px 0;
        color: #364159;
        font-weight: 600; 
        }
    th {
        z-index:99;
        //position: sticky;
        //top: 86px;
        padding: 12px 4px;
        /* background: ${theme['dash-background']}; */
        background: #f8f8f8;
        border: none;
        &:first-child:after,
        &:last-child:after {
            height: 100%;
        }
        &:first-child:after {
            border-left: 1px solid #bac0cb;
        }
        &:last-child:after {
            border-right: 1px solid #bac0cb;
        }

        &:after,
        &:before {
            position: absolute;
            left: 0;
            width: 100%;
        }
        &:before {
            top: 0;
            border-top: 1px solid #bac0cb;
            &:first-child {
            }
        }
        &:after {
            bottom: 0;
            border-bottom: 1px solid #bac0cb;
        }
        input {
            /* this allows the checkbox to be clicked, otherwise the position sticky of the th blocks the click */
            position: relative;
            z-index: 1;
        }
    }
    td {
        min-height: 36px;
        padding: ${Utils.isMobile() ? '12px' : '24px'} 4px;
        color: #606A80;
        font-weight: bold;

        .rate {
            font-size: 10px;
            font-weight: 400;
            margin-left: 5px;
        }
    }
    tr:hover td {
        background: ${theme.info}26;
    }
    thead th {
        font-family: ${theme['font-semibold']};
        color: ${theme['darker-borders']};
        text-align: left;
    }
    td:first-child,
    th:first-child {
        padding-left: 22px;
    }
    /* tr:hover td {
        i:last-child {
            color: ${theme['link-button']};
        }
    } */

    .drop-down {
        color: transparent;
    }

    /* .table-row {
        cursor: pointer;
    }

    .table-row:hover {
        .drop-down {
            color: ${theme['link-button']};
        }

    } */
`
// ${({ multipleSelect }) =>
// multipleSelect
//     ? css`
//           user-select: none;
//       `
//     : ''}

export const Date = styled.div`
    display: flex;
    align-items: center;
`

export const ActionButton = styled.div`
    i {
        color: ${({ action }) => (action === 'delete' ? theme['brand-danger'] : theme.icons)};
        margin-right: 5px;
        font-size: 14px;
        width: 14px;
    }
`
